import { i18n } from '@tt4b/ttam-i18n';

export const utm2TextMapObj = {
  utm_source: () => i18n.t('creative_utm_source_label'),
  utm_medium: () => i18n.t('creative_utm_medium_label'),
  utm_content: () => i18n.t('creative_utm_content_label'),
  utm_campaign: () => i18n.t('creative_utm_name_label'),
};
